export const PRODUCT_LISTING_PAGE_TAG: string = 'plp';
export const SEARCH_LANDING_PAGE_TAG: string = 'slp';
